import React from 'react'
import ScratchCards from './ScratchCards'
import ReferralProgram from './ReferralProgram'

const UnregisteredReferralPage = () => {
  return (
    <div>

      <div className="container">



        <div className="container-fluid p-0 p-md-5 col-lg-12">


          <div className="text-center pt-2 pb-3">
            <h2 className="sm-25">Rewards & Coupons</h2>
          </div>

          <div className="d-flex flex-wrap justify-content-between">
            {/* Online Course Box */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
              <div className="border card bg-white mt-1 rounded-4 box-shadow hover-scale p-3 hover-purple">
                <h2 className="text-center mt-2">Online Course</h2>
                <p className="text-center ">Everything you need to learn a new skill from your home</p>
                <div className="mt-3">
                  <div className="d-flex align-items-center">
                    👨‍💻 <p className="ms-1">Daily online class</p>
                  </div>
                  <div className="d-flex align-items-center">
                    ▶️<p className="ms-1">Daily class recording</p>
                  </div>
                  <div className="d-flex align-items-center">
                    🕖<p className="ms-1">24/7 Mentor support</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💻<p className="ms-1">Premium Notes & Softwares</p>
                  </div>
                  <div className="d-flex align-items-center">
                    👩🏻‍💼<p className="ms-1">Placement trainings</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💯<p className="ms-1">100% Placement assistance</p>
                  </div>
                </div>
                {/* <div className="pay mt-3 ps-3">
            <div className="d-flex mb-1">
                <p className="m-0">They pay</p>
                <div className="border border-dark rounded-3 ms-2">-20%</div>
            </div>
            <div className="d-flex">
                <s>₹2,628.00</s>
                <p className="ms-1">
                    <b>₹2,102.40</b>
                </p>
            </div>
        </div> */}
                <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                  🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                  <h5 className="ms-3 sm-16 m-0 mt-2">₹150</h5>
                </div>
                <div className="d-flex mt-4 mb-2">





                  <button
                    className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"

                  >
                    <h6 className="button">Refer to Friend</h6>
                  </button>



                </div>
              </div>
            </div>

            {/* Specialization Course Box */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
              <div className="border card bg-white rounded-4 box-shadow hover-scale p-3 hover-purple">
                <h2 className="text-center mt-3">Specialization Course</h2>
                <p className="text-center ">Everything you need to land your dream job</p>
                <div className="mt-3">
                  <div className="d-flex mt-1 align-items-center">
                    👨‍💻 <p className="ms-1">Daily online class</p>
                  </div>
                  <div className="d-flex align-items-center">
                    ▶️<p className="ms-1">Daily class recording</p>
                  </div>
                  <div className="d-flex align-items-center">
                    🕖<p className="ms-1">24/7 Mentor support</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💻<p className="ms-1">Premium Notes & Softwares</p>
                  </div>
                  <div className="d-flex align-items-center">
                    👩🏻‍💼<p className="ms-1">Placement trainings</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💯<p className="ms-1">100% Placement assistance</p>
                  </div>
                </div>
                {/* <div className="bg1 mt-3 ps-3">
            <div className="d-flex mb-2">
                <p className="m-0">They pay</p>
                <div className="border border-dark rounded-3 ms-2">-20%</div>
            </div>
            <div className="d-flex">
                <s>₹4,540.00</s>
                <p className="ms-1">
                    <b>₹3,638.40</b>
                </p>
            </div>
        </div> */}
                <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                  🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                  <h5 className="ms-3 sm-16 m-0 mt-2">₹250</h5>
                </div>
                <div className="d-flex mt-4 mb-2">


                  <button
                    className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"

                  >
                    <h6 className="button">Refer to Friend</h6>
                  </button>
                </div>
              </div>
            </div>

            {/* Offline Course Box */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
              <div className="border card bg-white rounded-4 box-shadow hover-scale p-3 hover-purple">
                <h2 className="text-center mt-3">Offline Course</h2>
                <p className="text-center ">Everything you need to master skills with us</p>
                <div className="mt-3">
                  <div className="d-flex align-items-center">
                    👨‍💻 <p className="ms-1">Daily online class</p>
                  </div>
                  <div className="d-flex align-items-center">
                    ▶️<p className="ms-1">Daily class recording</p>
                  </div>
                  <div className="d-flex align-items-center">
                    🕖<p className="ms-1">24/7 Mentor support</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💻<p className="ms-1">Premium Notes & Softwares</p>
                  </div>
                  <div className="d-flex align-items-center">
                    👩🏻‍💼<p className="ms-1">Placement trainings</p>
                  </div>
                  <div className="d-flex align-items-center">
                    💯<p className="ms-1">100% Placement assistance</p>
                  </div>
                </div>
                {/* <div className="bg1 mt-3 ps-3">
            <div className="d-flex mb-2">
                <p className="m-0">They pay</p>
                <div className="border border-dark rounded-3 ms-2">-20%</div>
            </div>
            <div className="d-flex">
                <s>₹10,188.00</s>
                <p className="ms-1">
                    <b>₹8,150.40</b>
                </p>
            </div>
        </div> */}
                <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                  🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                  <h5 className="ms-3 sm-16 m-0 mt-2">₹500</h5>
                </div>
                <div className="d-flex mt-4 mb-2">





                  <button
                    className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"

                  >
                    <h6 className="button">Refer to Friend</h6>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>




    </div>
  )
}

export default UnregisteredReferralPage